/**
 * Returns Logo icon class names for consumer and enterprise
 */
export default function getLogoIconClassNames(isConsumer: boolean): string[] {
    const classNames: string[] = [];
    if (isConsumer) {
        classNames.push('sidePaneHeader-outlook-logo');
    } else {
        classNames.push('sidePaneHeader-office-logo');
    }

    return classNames;
}
